export default "__VITE_ASSET__3pYLPnNK__"